import {
  getContent,
  mergeContent,
  newModal,
  mergeModalState,
  closeModal,
} from "@js/helpers/state.js";

import {
  CE_MODAL_UPLOAD_FROM_FILE_OPEN,
  CE_MODAL_UPLOAD_FROM_FILE_SAVE,
  CE_MODAL_UPLOAD_FROM_FILE_LOAD_FILE,
} from "@js/actions/studio/campaign_content_section/modal_upload_from_file.js";

const validate = (state) => {
  let size = state.modal.state.size;
  let megabyte = 1024 * 1024;
  let sizeInMB = size / megabyte;

  if (sizeInMB > 10) {
    return mergeModalState(state, {
      validation_error: t("phrases.react_content.must_be_under_10_mb"),
    });
  } else {
    return mergeModalState(state, {
      validation_error: null,
    });
  }
};

const ModalUploadFromFile = (state = {}, action) => {
  switch (action.type) {
    case CE_MODAL_UPLOAD_FROM_FILE_OPEN:
      return newModal(state, "upload_from_file", {
        client_content_id: action.client_content_id,
        format: null, // are we writing the data to text or html?
        validation_error: null,
        download_error: null,
      });

    case CE_MODAL_UPLOAD_FROM_FILE_LOAD_FILE:
      if (!action || !action.file) return state;

      // In this process, we can handle erros after the fact, since we maintain
      // the file even if it's too large.
      let stateBeforeErrorChecking = mergeModalState(state, {
        file: action.file,
        fileContents: action.fileContents,
        size: action.size,
      });
      return validate(stateBeforeErrorChecking);

    case CE_MODAL_UPLOAD_FROM_FILE_SAVE:
      let {
        client_content_id,
        fileContents,
        validation_error,
      } = state.modal.state;
      if (!fileContents) {
        //No file loaded, return state
        return state;
      }
      if (validation_error) {
        return state;
      }

      let content = getContent(state, client_content_id);
      // We may need to upgrade from "html" or "text" to "both" if we didn't
      // already include the format that we're writing.
      let dstFormat = action.format || "html";
      let newFormat =
        content.format == "both" || content.format == dstFormat
          ? content.format
          : "both";
      return mergeContent(closeModal(state), client_content_id, {
        [dstFormat]: fileContents,
        format: newFormat,
        active_html_editor:
          dstFormat === "html" ? "textarea" : content.active_html_editor,
      });

    default:
      return state;
  }
};

export default ModalUploadFromFile;
